import { Metadata } from '../../../../utils/spds/metadata';
import Super from './ghost.gjs';

const METADATA = Metadata.define({
  description: `
    Link button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Link Button',
});

export default class SpdsActionButtonLink extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  link = true;

  get classesToMap() {
    return [...super.classesToMap, 'link'];
  }
}

export const ACTION_BUTTON_LINK_METADATA = SpdsActionButtonLink.metadata;
